import { render, staticRenderFns } from "./card-info.vue?vue&type=template&id=e476d6e6&scoped=true"
import script from "./card-info.vue?vue&type=script&lang=ts"
export * from "./card-info.vue?vue&type=script&lang=ts"
import style0 from "./card-info.vue?vue&type=style&index=0&id=e476d6e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e476d6e6",
  null
  
)

export default component.exports